import React from 'react';
import styles from './language.module.scss';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import { ArmenianFlag, RussianFlag, UnitedStatesFlag } from '../../../../../../../../Assets/Icons';

interface IProps {
    logo: string,
    onSelect: (active: string) => void
};

interface ILanguage {
    title: string,
    icon: string,
    code: string
};

const Language: React.FC<IProps> = ({ logo, onSelect }) => {
    const { baseURL } = useNoAuthHooks();
    const languages: ILanguage[] = [
        {
            title: 'Հայերեն',
            icon: ArmenianFlag,
            code: "hy",
        },
        {
            title: 'Русский',
            icon: RussianFlag,
            code: "ru",
        },
        {
            title: 'English',
            icon: UnitedStatesFlag,
            code: "en",
        },
    ];
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={`${baseURL}${logo}`} alt='logo.png' className={styles.logo} />
                <div className={styles.welcome}>
                    <p className={styles.bigText}>
                        Welcome!
                    </p>
                    <p className={styles.smallText}>
                        Please choose your menu language.
                    </p>
                </div>
            </div>
            <div className={styles.body}>
                {
                    languages.map((el) => {
                        return (
                            <div className={styles.langRow} key={el.code} onClick={() => onSelect(el.code)}>
                                <p>{el.title}</p>
                                <img src={el.icon} alt={`${el.icon}.svg`} />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Language
